<template>
  <div class="itemContent">
    <div class="user_info">
      <div class="user_info_left">
        <img :src="data.avatar ? data.avatar : state.defaultAvatar" alt="" />
        <div class="user_title">
          <img
            v-if="data.vip == '1'"
            src="../../../assets/game/yz_game_commentmonthVip01.png"
            alt=""
          />
          <span>{{ data.full_name }}</span>
          
        </div>
      </div>
    </div>
    <div
      class="user_comment"
      v-if="state.uid == data.uid || state.topicType != '2'"
    >
      <!-- <div class="user_comment"> -->
      <div :style="data.isExpend ? `` : `-webkit-line-clamp: 5;`" @click="changeExpend(data)">
        <p v-html="data.content" class="article-content"></p>
      </div>
      <div v-if="data.pic">
        <img :src="data.pic" alt="" @click="openImg(data.pic)" />
      </div>
    </div>
    <div class="user_comment hiddenComment" v-else>
      <p>此评论暂不可查看</p>
    </div>

    <div class="user_bottom">
      <div class="user_bottom_left">
        <slot name="index"></slot>
        <span class="time">{{ data.createtime }}</span>
      </div>
      <div class="user_bottom_right">
        <div class="like" @click="likeThisComment(data.id)">
          <img
            src="../../../assets/game/yz_game_likeComunity.png"
            alt=""
            v-if="state.isLike.includes(data.id)"
          />
          <img
            src="../../../assets/game/yz_game_notLikeComunity.png"
            alt=""
            v-else
          />
          <span>{{ data.good }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, defineEmits, reactive, onActivated } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { getQueryString } from "../../../utils/location";
import touxiang from "@/assets/touxiang_reset.png";

const props = defineProps({
  data: {
    type: Object,
    default: () => {},
  },
  like: {
    type: Array,
    default: () => [],
  },
  topicType: {
    type: Number,
    default: 1,
  },
});

//子组件触发父组件事件
const emit = defineEmits(["likeThisComment", "openInagePreview"]);

const store = useStore();

const changeExpend = (data)=>{
  data.isExpend = !data.isExpend
}

const state = reactive({
  isLike: [],
  uid: getQueryString("uid"),
  topicType: props.topicType,
  defaultAvatar: touxiang,
});

onMounted(() => {
  // console.log("评论信息组件挂载了---------------------", state.uid);
  state.isLike = props.like;
  state.topicType = props.topicType;
});

const likeThisComment = (id) => {
  emit("likeThisComment", id);
};
const openImg = (url) => {
  emit("openInagePreview", url);
};
</script>

<style scoped>
.van-cell-group {
  background-color: #f7f8fa;
}
.itemContent {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 24px;
  border-radius: 20px;
}
.user_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user_info .user_info_left {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.8;
  letter-spacing: 0.5px;
}
.user_info .user_info_left .user_title {
  display: flex;
  align-items: center;
}
.user_info .user_info_left .user_title img {
  width: 32px;
  height: 32px;
}
.user_info .user_info_left img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 24px;
}
.user_info .user_info_left div img {
  width: 56px;
  height: 22px;
  margin-left: 4px;
  border-radius: 0;
}
.user_info .user_info_left div {
  color: #333;
  padding-top: 10px;
}
.user_info .user_info_left div div {
  display: flex;
  align-items: center;
  line-height: 0;
}
.time {
  font-size: 24px;
  color: #999999;
  margin-left: 10px;
}
.user_info .user_info_right {
  /* width: 105px; */
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #ff6666;
  padding: 4px 8px;
  border-radius: 6px;
  color: #333;
}
.user_info .user_info_right span {
  font-size: 16px;
}
.user_comment {
  width: 638px;
  min-height: 30px;
  margin-left: 120px;
  font-size: 30px;
  color: #333;
  /* margin-top: 8px; */
}
.user_comment div {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /* -webkit-line-clamp: 5; */
  text-overflow: ellipsis;
}
.user_comment div p {
  text-overflow: ellipsis;
  padding-right: 120px;
}
.user_comment img {
  margin-top: 20px;
  width: 308px;
  /* min-height: 200px */
}
.user_comment ul {
  display: flex;
  position: relative;
  padding-top: 32px;
}
.user_comment ul li {
  height: 100%;
}
.user_comment div:nth-of-type(2) img {
  margin-right: 16px;
  border-radius: 10px;
  height: 100%;
}
.user_bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 120px;
  font-size: 24px;
  color: #999999;
  margin-top: 20px;
}
.user_bottom .user_bottom_right {
  display: flex;
  align-items: center;
  font-size: 30px;
}
.user_bottom .user_bottom_right div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.user_bottom .user_bottom_right img {
  width: 36px;
  height: 36px;
  margin-right: 4px;
  margin-bottom: 6px;
}
.user_bottom_right .review {
  display: flex;
  align-items: center;
  margin-right: 34px;
}

.giveComment {
  width: 100px;
  height: 100px;
  border-radius: 100px;
  position: fixed;
  right: 40px;
  bottom: 250px;
  background: linear-gradient(135deg, #8061ff 0%, #9c85fb 100%);
  border: 6px solid #664fc3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  font-size: 20px;
}
.giveComment img {
  width: 40px;
  height: 40px;
}
.backToTop {
  position: fixed;
  right: 40px;
  bottom: 100px;
}
.backToTop img {
  width: 100px;
  height: 100px;
}
:deep(.van-cell:after) {
  position: relative;
}

.user_comment .moreImg {
  width: 308px;
  height: 100%;
  position: absolute;
  right: 8px;
  /* top: 32px; */
  color: #fff;
  font-size: 50px;
  padding-bottom: 50px;
}
.user_comment .moreImg span {
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 101%;
  background: rgba(0, 0, 0, 0.35);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hiddenComment {
  color: #12cec7;
}
</style>
